import * as api from "../api/usersAPI";
import * as types from "../constants/usersConstants";

export const fetchOrgUsersAction = (organisationId) => async (dispatch) => {
  try {
    const { error, data } = await api.fetchOrgUsers(organisationId);
    if (error) throw new Error(error);
    dispatch({ type: types.FETCH_ORG_USERS_SUCCESS, payload: data.users });
  } catch (error) {
    dispatch({ type: types.FETCH_ORG_USERS_FAIL, payload: error.message });
  }
};

export const changeUserRoleAction =
  (organisationId, userId, role) => async (dispatch) => {
    const { error, data } = await api.changeUserRole(
      organisationId,
      userId,
      role
    );
    if (error) throw new Error(error);
    dispatch({ type: types.UPDATE_ORG_USER, payload: data.user });
    return data;
  };

export const removeOrgUserAction =
  (organisationId, userId) => async (dispatch) => {
    const { error, data } = await api.removeOrgUser(organisationId, userId);
    if (error) throw new Error(error);
    dispatch({ type: types.REMOVE_ORG_USER, payload: userId });
    return data;
  };

export const fetchInvitationsAction = (organisationId) => async (dispatch) => {
  try {
    const { error, data } = await api.fetchInvitations(organisationId);
    if (error) throw new Error(error);
    dispatch({
      type: types.FETCH_INVITATIONS_SUCCESS,
      payload: data.invitations,
    });
  } catch (error) {
    dispatch({ type: types.FETCH_INVITATIONS_FAIL, payload: error.message });
  }
};

export const sendInvitationAction =
  (organisationId, email, role) => async (dispatch) => {
    const { error, data } = await api.sendInvitation(
      organisationId,
      email,
      role
    );
    if (error) throw new Error(error);
    dispatch({ type: types.ADD_INVITATION, payload: data.invitation });
    return data;
  };

export const revokeInvitationAction =
  (organisationId, invitationId) => async (dispatch) => {
    const { error, data } = await api.revokeInvitation(
      organisationId,
      invitationId
    );
    if (error) throw new Error(error);
    dispatch({ type: types.REMOVE_INVITATION, payload: invitationId });
    return data;
  };

export const resendInvitationAction =
  (organisationId, invitationId) => async () => {
    const { error, data } = await api.resendInvitation(
      organisationId,
      invitationId
    );
    if (error) throw new Error(error);
    return data;
  };
